//  to={`/products/designs?product_id=${
//                 selectedDesigns[0]?.product_id
//               }&page=${backPage}${search ? `&search=${search}` : ""}`}

import React, { useEffect, useRef } from "react";
import Barcode from "react-barcode";
import { useLocation, Link } from "react-router-dom";
import JsBarcode from "jsbarcode";

export default function BarcodeList() {
  const location = useLocation();
  const { selectedDesigns } = location.state || { selectedDesigns: [] };
  const queryParams = new URLSearchParams(location.search);
  const backPage = parseInt(queryParams.get("page"));
  const search = queryParams.get("search");
  const barcodeRef = useRef(null);

  const SVGBarcode = ({ value }) => {
    const svgRef = useRef(null);

    useEffect(() => {
      if (svgRef.current) {
        JsBarcode(svgRef.current, value, {
          format: "CODE128",
          width: 2, // narrow bar
          height: 70, // tall enough for thermal
          displayValue: false,
          margin: 0,
        });
      }
    }, [value]);

    return <svg ref={svgRef} className="barcode1" />;
  };

  const handlePrint = () => {
    if (barcodeRef.current) {
      const printWindow = window.open("", "_blank");
      if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <style>
                @page {
                  size: 100mm 50mm;
                  margin: 0;
                }
                @media print {
                  body {
                    margin: 0;
                    padding: 0;
                    -webkit-print-color-adjust: exact;
                  }
                  .barcode1 {
                    width: 100%;
                    margin: 0;
                    padding: 0;
                    margin-bottom: 2mm;
                  }
                  .col-md-6 {
                    width: 100mm;
                    height: 50mm;
                    padding: 0;
                    margin: 0 auto;
                    page-break-after: always;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  }
                  .card {
                    width: 100mm;
                    height: 50mm;
                    border: none;
                    box-shadow: none;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }
                  .card-body {
                    width: 100mm;
                    padding: 0;
                    text-align: center;
                    // margin: 3mm;
                  }
                  .barcode {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: center;
                    padding: 2mm;
                  }
                  .info-row {
                    display: flex;
                    justify-content: space-between;
                    width: 100mm;
                    color: black;
                    font-weight: bold;
                    // font-size: 12pt;
                    // font-family: sans-serif;
                    font-family: 'Courier New', monospace;
                    font-size: 20px;                      
                    // color: #000;                          
                    -webkit-font-smoothing: none;
                    font-smooth: never;
                    text-rendering: optimizeLegibility;
                  }
                  .info-cell {
                    text-align: right;
                    padding-right: 8px;
                    margin-bottom: 1mm;
                  }
                  .info-cell.right {
                    text-align: left;
                    padding-left: 8px;
                    margin-bottom: 1mm;
                  }
                  .col-5 {
                    width: 35mm;
                  }
                  .col-7 {
                    width: 65mm;
                  }
                }
              </style>
            </head>
            <body>
              <div>${barcodeRef.current.innerHTML}</div>
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }
    }
  };

  const formatPrice = (rate) => {
    const price = parseInt(rate.replace("₹", "").split(".")[0], 10) + 10;
    const formattedPrice =
      price >= 1000
        ? `4${price.toString().charAt(0)} / ${price
            .toString()
            .slice(-3)
            .padStart(3, "0")}`
        : `4${price.toString().charAt(0)} / ${price
            .toString()
            .slice(-2)
            .padStart(2, "0")}`;
    return formattedPrice;
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="form-head d-flex justify-content-between align-items-center mb-3">
          <h4>Barcode List</h4>
          <div className="d-flex align-items-center">
            <img
              src="/assets/images/kidskart/icon/printer.png"
              alt="Print Icon"
              className="cursor-pointer me-3"
              onClick={handlePrint}
              title="Print Barcodes"
            />
            <Link
              to={`/products/designs?product_id=${
                selectedDesigns[0]?.product_id
              }&page=${backPage}${search ? `&search=${search}` : ""}`}
            >
              <img
                src="/assets/images/kidskart/icon/back-button.png"
                alt="Back"
                title="Back to Designs"
              />
            </Link>
          </div>
        </div>

        <div className="row" ref={barcodeRef}>
          {selectedDesigns.map((design, index) => (
            <div className="col-md-6 mb-4 m-0" key={index}>
              <div className="card shadow-sm">
                <div className="card-body text-center">
                  <div className="barcode text-black">
                    <SVGBarcode value={design.design_id} />
                    <div className="info-row row">
                      <div className="info-cell width-30 col-5">
                        {design.barcode_date}
                      </div>
                      <div className="info-cell right width-70 col-7">
                        {design.design_id}
                      </div>
                    </div>
                    <div className="info-row row">
                      <div className="info-cell width-30 col-5">
                        {formatPrice(design.design_rate)}
                      </div>
                      <div className="info-cell right width-70 col-7">
                        {design.brand_name}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
